// /**
//  * Warwhouse - Add
//  */

// React
import React, {useState, useContext, useEffect} from 'react';
// Context
import AuthContext from '../../../../authContext';

// react hook form
import {Controller, useForm} from 'react-hook-form';

// UI
import theme from '../../../../theme';
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';
import {
  TextField,
  Grid,
  Button,
  CircularProgress,
  Paper,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  DialogContent,
  IconButton,
  DialogActions,
  Dialog,
  FormHelperText,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from '../../../../components/Modal';
import AddItemsParcelsList from './addItemsParcelsList';
import AddItemsParcelsForm from './addItemsParcelsForm';
import AddInventoryItemsParcelsForm from './addInventoryItemsParcelsForm';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  TimePicker,
  DatePicker,
} from '@material-ui/pickers';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';

// Icon
import Icon from '@mdi/react';
import {
  mdiPhoneOutline,
  mdiAccountTieOutline,
  mdiMapMarkerOutline,
  mdiPlus,
  mdiPackageVariantClosed,
  mdiCalendar,
  mdiArrowRight,
  mdiPrinter,
  mdiCalendarClock,
  mdiFormatListCheckbox,
  mdiWarehouse,
  mdiAccountOutline,
  mdiClose,
  mdiArchiveOutline,
  mdiCheck,
  mdiCubeSend,
  mdiCubeOutline,
  mdiCounter,
  mdiTableRowHeight,
  mdiTableColumnWidth,
  mdiRuler,
} from '@mdi/js';

// Client SDK
import Client from 'client-sdk/src/client';
import {GetAllWarehousesRequestBuilder} from 'client-sdk/src/warehouses/warehouses';

// Type
import {
  Parcel,
  ParcelItems,
  PayloadCreate,
  SelectorProps,
} from '../../interfaces';
import {
  AddItemCreateParcel,
  AddInventoryItemCreateParcel,
} from '../../../parcels/interfaces';
import {User} from '../../../users/interfaces';
import {Warehouse} from '../../../warehouses/interfaces';

// helpers'
import {
  flattenObject,
  removeEmptyValueObject,
  convertPersianDigit2English,
  checkHourisPast,
} from '../../../../utils/helpers';
import {Product} from '../../../products/interfaces';
import {Variant} from '../../../products/interfaces';
import {createParcelsActions} from '../../../parcels/actions';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import {Store} from '../../../../redux/reducers';
import {
  makeSelectCountList,
  makeSelectError,
  makeSelectList,
  makeSelectLoading,
} from '../../../parcels/selectors';

import {useHistory} from 'react-router-dom';
import moment from 'moment';
import ListDimensions from '../../../orderPack/dimensionsList';
import MapPosition from '../../../centers/components/mapPosition';


import handleError from '../../../../utils/handleError';
import handleNotfication from '../../../../utils/handleNotification';
import parcelRepository from 'client-sdk/src/Repository/parcels-repository';


jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true});

type Props = {
  create: (body: any) => void;
  onClose: () => void;
  warehouseId: number;
  createParcelsDispatch: (payload: PayloadCreate) => void;
};

type Inputs = {
  agentName: string;
  agentPhoneNumber: string;
  deliveryDate: string;
  pickAddress: string;
  pickDate: string;
  pickTime: string;
  deliveryTime: string;
  destinationId: number;
  deliveryType: string;
  id: number;
  items: ParcelItems[];
  deliveryStartTime: string;
  deliveryEndTime: string;
  sourceId: number;
  status: string;
  sourceWarehouseName: string;
  destinationWarehouseName: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      marginLeft: '20px',
      marginRight: '20px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.success.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

function useOnMount(handler: any) {
  return React.useEffect(handler, []);
}

function required(displayName: any) {
  return function validateRequired(value: any) {
    return value !== null || `${displayName} is required.`;
  };
}

function Add(props: Props) {
  const classes = useStyles();
  const authContext = useContext(AuthContext);
  const history = useHistory();
  const {
    register,
    handleSubmit,
    errors,
    control,
    watch,
    setValue,
    getValues,
  } = useForm<Inputs>({
    defaultValues: {
      deliveryType: '',
      deliveryTime: '',
      deliveryDate: null,
      pickDate: null,
      pickTime: null,
      deliveryStartTime: null,
      deliveryEndTime: null,
    },
  });

  const [items, setItems] = useState<any>([]);
  const [item, setItem] = useState<any>({});
  const [deliveryType, setDeliveryType] = useState<any>('');
  const [transportationType, setTransportationType] = useState<any>('');
  const [itemDeleted, setItemDeleted] = useState<any>({});
  const [id, setId] = useState<any>(1);
  const [itemsInfo, setItemsInfo] = useState<any>([]);
  const [inventoryItems, setInventoryItems] = useState<any>([]);
  const [productObject, setProductObject] = useState<Product>({});
  const [variantObject, setVariantObject] = useState<Variant>({});
  const [hasExpirationDateTime, setHasExpirationDateTime] = React.useState(
    false
  );
  const [itemCount, setItemCount] = useState<any>(0);
  const [openAddItem, setOpenAddItem] = useState(false);
  const [openAddInventoryItem, setOpenAddInventoryItem] = useState(false);
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
  const [destinationId, setDestinationId] = useState(0 as number);
  const [valueWarehouse, setValueWarehouse] = React.useState<Warehouse | null>(
    null
  );
  const [checkSubmit, setCheckSubmit] = React.useState(false as boolean);
  const [parcelsData, setParcelsData] = React.useState({});
  const [options, setOptions] = React.useState<Warehouse[]>([]);
  const [openDimensions, setOpenDimensions] = useState(false as boolean);
  const [openListDimensions, setOpenListDimensions] = useState(
    false as boolean
  );
  const [dimensions, setDimensions] = useState<any>([]);
  const [boxCount, setBoxCount] = useState('');
  const [totalBoxCount, setTotalBoxCount] = useState(0);
  const [latLng, setLatLng] = useState({lat: 0, lng: 0} as {
    lat: number;
    lng: number;
  });
  const [count, setCount] = useState('');
  const [length, setLength] = useState('');
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const loading = openAutocomplete && options.length === 0;


    const [parcelsList, setParcelsList] = useState([]);
    const [counts, setCounts] = useState<number>(0);
    const [error, setError] = useState<string>('');
    const [loadings, setLoadings] = useState<boolean>(false);


  React.useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    (async () => {
      const token = localStorage.getItem('token') || '';
      const makeRequest = new GetAllWarehousesRequestBuilder()
        .params({
          'status.equals': 'ACTIVE',
          size: 100,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      const warehouses = response.data as any;
      if (active) {
        setOptions(warehouses as Warehouse[]);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!openAutocomplete) {
      setOptions([]);
    }
  }, [openAutocomplete]);

  const addDimensions = () => {
    const newDimension = {
      count,
      length,
      width,
      height,
    };
    setDimensions([...dimensions, newDimension]);
    setCount('');
    setLength('');
    setHeight('');
    setWidth('');
  };

  useEffect(() => {
    let totalCount: any = 0;
    dimensions.forEach((dimension: any) => {
      totalCount += Number(dimension.count);
    });
    setTotalBoxCount(totalCount);
  }, [dimensions]);

  const checkButtonDisabled = () => {
    const fields = [count, length, width, height];
    return fields.some(field => !field) && totalBoxCount < Number(boxCount);
  };

  const handleCloseDimensions = () => {
    setOpenDimensions(false);
    setBoxCount('');
    setOpenListDimensions(false);
    setDimensions([]);
  };

  const setUpdateStatus = () => {
    setCheckSubmit(true);
  };

  const onSubmit = (data: Inputs) => {
    let ronadTransportationDTO;
    const {
      agentName,
      agentPhoneNumber,
      deliveryDate,
      deliveryTime,
      deliveryStartTime,
      deliveryEndTime,
      pickAddress,
      pickDate,
      pickTime,
    } = data;

    ronadTransportationDTO = {
      lat: latLng.lat,
      lon: latLng.lng,
      pickAddress,
      pickDate,
      pickTime: pickTime?.substr(10),
    };

    if (transportationType === 'PARTNER') {
      ronadTransportationDTO = {};
    }

    addParcel({
      agentName,
      agentPhoneNumber,
      deliveryType,
      items,
      partnerId: authContext?.user?.partnerId,
      deliveryDate,
      transportationType,
      ronadTransportationDTO,
      deliveryStartTime: convertPersianDigit2English(
        deliveryTime.substring(0, 2).concat(':00:00')
      ),
      deliveryEndTime: convertPersianDigit2English(
        deliveryTime.substring(3, 5).concat(':00:00')
      ),
      destinationId,
      shippingDate: convertPersianDigit2English(moment().format('YYYY-MM-DD')),
    });
  };

  const addParcel = (body: any) => {
    setParcelsData(body);
    handleOpenCheckConfirm();
  };

  const createItemsToParcels = (body: AddItemCreateParcel) => {
    const {
      count,
      product,
      variant,
      boxCount,
      category,
      countOfBox,
      hasExpirationDate,
      unitCost,
    } = body;
    setHasExpirationDateTime(hasExpirationDate);
    setId(id + 1);
    setProductObject(product);
    setVariantObject(variant);
    setItemCount(count);
    const idItem = product?.id;
    const variantId = variant?.id;
    const name = product?.name;
    const categoryName = category?.name;
    setItemsInfo([
      ...itemsInfo,
      {
        id,
        productId: idItem,
        count,
        name,
        boxCount,
        countOfBox,
        product,
        variant,
      },
    ]);

    if (variantId) {
      setItem({
        variantId,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
      });
    } else {
      setItem({
        productId: idItem,
        count,
        packageCount: boxCount ?? 1,
        packageAmount: countOfBox ?? Number(count),
      });
    }
    if (hasExpirationDate) {
      setOpenAddInventoryItem(true);
    } else {
      setItems([
        ...items,
        {
          variantId,
          productId: idItem,
          count,
          packageCount: boxCount ?? 1,
          packageAmount: countOfBox ?? Number(count),
          inventoryItems: [
            {
              amount: Number(count),
              unitCost: unitCost ?? 0,
              productionDate: null,
              expirationDate: null,
            },
          ],
        },
      ]);
      setOpenAddItem(false);
    }
  };

  const createInventoryItemsToParcels = (
    body: AddInventoryItemCreateParcel[]
  ) => {
    setInventoryItems(body);
    setItems([...items, {...item, inventoryItems: body}]);
    setOpenAddInventoryItem(false);
    setOpenAddItem(false);
  };

  const setConfirmDelete = (body: any) => {
    setOpenConfirmDelete(true);
    setItemDeleted(body);
  };

  const handleOpenCheckConfirm = () => {
    if (transportationType === 'PARTNER') {
      setCheckSubmit(true);
    } else {
      setOpenDimensions(true);
    }
  };

  const handleCloseCheckConfirm = () => {
    setCheckSubmit(false);
  };

  const handleClose = () => {
    setOpenConfirmDelete(false);
  };

  const handleChangeDeliverType = (
    event: React.ChangeEvent<{value: unknown}>
  ) => {
    setDeliveryType(event.target.value as string);
  };

  const deleteItemsToParcels = () => {
    const newValue = items.filter((item: any) => item.id !== itemDeleted.id);
    const newValueInfo = itemsInfo.filter(
      (item: any) => item.id !== itemDeleted.id
    );

    setItems(newValue);
    setItemsInfo(newValueInfo);
    setOpenAddItem(false);
    handleClose();
  };

    const createParcels = async (actions: any) => {
      const payload = {...actions};
      try {
        setLoadings(true);
        const {pagination, callback, id} = await parcelRepository.createParcel({
          payload,
        });
        handleNotfication('محموله با موفقیت اضافه شد', 'success');
        callback && callback();
      } catch (error) {
        setError(error.message);
        handleNotfication('اضافه کردن محصول با خطا مواجه شد', 'error');
        handleError(error.response);
      } finally {
        setLoadings(false);
      }
    };

  const handleCreateParcel = () => {
    const parcelData = {...parcelsData, parcelPackages: dimensions};
    createParcels({
      body: parcelData,
      pagination: {
        sourceWarehouseId: {equals: authContext.user?.warehouseId},
      },
      callback: () => {
        setParcelsData({});
        history.push('/parcels-sender');
      },
    });
    handleCloseDimensions();
    setCheckSubmit(false);
  };

  const handleDeliveryDateChange = (date: any) => {
    setValue(
      'deliveryDate',
      convertPersianDigit2English(date.format('YYYY-MM-DD'))
    );
    setValue('deliveryTime', '');
  };

  const handlePickDateChange = (date: any) => {
    setValue(
      'pickDate',
      convertPersianDigit2English(date.format('YYYY-MM-DD'))
    );
  };

  const handleEndDateChange = (date: any) => {
    setValue(
      'deliveryEndTime',
      convertPersianDigit2English(date.format('YYYY-MM-DD HH:mm:ss'))
    );
  };

  useOnMount(() => {
    register(
      {name: 'deliveryDate', type: 'text'},
      {validate: required('تاریخ تحویل را وارد کنید')}
    );
    register({name: 'pickDate', type: 'text', defaultValue: ''});
    register({name: 'pickTime', type: 'text', defaultValue: ''});
  });

  const values = getValues();

  return (
    <>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        ایجاد محموله جدید
        `}
        </Typography>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button>
      </Grid>
      <form style={{display: 'flex'}} onSubmit={handleSubmit(onSubmit)}>
        <Grid
          container
          style={{margin: '30px 0'}}
          spacing={5}
          alignItems="flex-start"
        >
          <Paper
            elevation={3}
            className={classes.paper}
            variant="elevation"
            square
          >
            <div style={{marginTop: '-66px'}} className={classes.addIcon}>
              <Icon
                path={mdiPackageVariantClosed}
                size={4}
                color={theme.palette.green.main}
              />
            </div>
            <Grid
              style={{padding: '20px'}}
              container
              spacing={5}
              alignItems="flex-start"
            >
              <Grid container item xs={6} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiWarehouse}
                      size={1}
                      className={classes.icon}
                    />
                  </span>
                  <Grid item xs={11}>
                    <Autocomplete
                      open={openAutocomplete}
                      onOpen={() => {
                        setOpenAutocomplete(true);
                      }}
                      onClose={() => {
                        setOpenAutocomplete(false);
                      }}
                      getOptionSelected={(option, value) =>
                        option.name === value.name
                      }
                      getOptionLabel={option => option.name}
                      options={options}
                      loading={loading}
                      onChange={(event: any, newValue: any | null) => {
                        setDestinationId(newValue?.id);
                        setValueWarehouse(newValue);
                      }}
                      renderInput={params => (
                        <TextField
                          {...params}
                          label="مقصد"
                          inputRef={register({required: false})}
                          className={classes.textInput}
                          name="admin"
                          id="admin"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loading ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>
                </div>
              </Grid>
              <Grid container item xs={12} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiAccountOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <div style={{width: '100%'}}>
                    <TextField
                      fullWidth
                      id="agentName"
                      name="agentName"
                      label="نام مسئول حمل"
                      className={classes.textInput}
                      inputRef={register({required: true})}
                      error={errors.agentName && true}
                    />
                  </div>
                </div>
              </Grid>
              <Grid container item xs={6} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiPhoneOutline}
                      size={1}
                      className={classes.icon}
                      style={{transform: 'rotate(-90deg)'}}
                    />
                  </span>

                  <span style={{width: '100%'}}>
                    <TextField
                      fullWidth
                      id="agentPhoneNumber"
                      name="agentPhoneNumber"
                      label="شماره تماس مسئول حمل"
                      className={classes.textInput}
                      inputRef={register({required: true})}
                    />
                  </span>
                </div>
              </Grid>
              <Grid container item xs={6} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiFormatListCheckbox}
                      size={1}
                      className={classes.icon}
                      style={{transform: 'rotate(-180deg)'}}
                    />
                  </span>

                  <span style={{width: '100%'}}>
                    <FormControl style={{width: '100%'}}>
                      <InputLabel id="deliveryTypeLabel">
                        نوع بسته بندی
                      </InputLabel>
                      <Select
                        fullWidth
                        id="deliveryType"
                        name="deliveryType"
                        inputProps={{
                          name: 'deliveryType',
                          id: 'deliveryType',
                        }}
                        labelId="deliveryTypeLabel"
                        value={deliveryType}
                        onChange={handleChangeDeliverType}
                        className={classes.textInput}
                        inputRef={register({required: true})}
                      >
                        <MenuItem value={'BOX'}>کارتن</MenuItem>
                        <MenuItem value={'PALLET'}>پالت</MenuItem>
                        <MenuItem value={'BULK'}>فله</MenuItem>
                      </Select>
                    </FormControl>
                  </span>
                </div>
              </Grid>{' '}
              <Grid
                style={{marginTop: '15px'}}
                container
                item
                xs={6}
                sm={3}
                alignItems="flex-end"
              >
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCubeSend}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{width: '100%'}}>
                    <FormControl style={{width: '100%'}}>
                      <InputLabel id="transportationTypeLabel">
                        نوع ارسال
                      </InputLabel>
                      <Select
                        fullWidth
                        id="transportationType"
                        name="transportationType"
                        inputProps={{
                          name: 'transportationType',
                          id: 'transportationType',
                        }}
                        labelId="transportationTypeLabel"
                        value={transportationType}
                        onChange={e => setTransportationType(e.target.value)}
                        className={classes.textInput}
                        inputRef={register({required: true})}
                      >
                        <MenuItem value={'PARTNER'}>ارسال توسط خودم</MenuItem>
                        <MenuItem value={'RONAD'}>ارسال توسط روناد</MenuItem>
                      </Select>
                    </FormControl>
                  </span>
                </div>
              </Grid>{' '}
              <Grid container item xs={12} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendar}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span style={{width: '100%'}}>
                    <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                      <DatePicker
                        id="deliveryDate"
                        name="deliveryDate"
                        label="تاریخ تحویل محموله"
                        format="jYYYY/jMM/jDD"
                        disablePast
                        margin="normal"
                        disableToolbar
                        fullWidth
                        okLabel="تأیید"
                        cancelLabel="لغو"
                        defaultValue={null}
                        className={classes.textInput}
                        value={values.deliveryDate}
                        onChange={handleDeliveryDateChange}
                        error={errors.hasOwnProperty('deliveryDate')}
                        helperText={
                          errors.deliveryDate && errors.deliveryDate.message
                        }
                      />
                    </MuiPickersUtilsProvider>
                  </span>
                </div>
              </Grid>
              <Grid container item xs={12} sm={3} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiCalendarClock}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <span
                    style={{
                      width: '100%',
                      marginTop: '16px',
                      marginBottom: '8px',
                    }}
                  >
                    <Controller
                      rules={{required: true}}
                      style={{width: '100%'}}
                      control={control}
                      name="deliveryTime"
                      label="بازه تحویل محموله"
                      as={
                        <TextField
                          select
                          fullWidth
                          error={!!errors.deliveryTime && !!errors.deliveryTime}
                        >
                          <MenuItem
                            disabled={checkHourisPast(9, values.deliveryDate)}
                            value={'09-11'}
                          >
                            {'9 الی 11'}
                          </MenuItem>
                          <MenuItem
                            disabled={checkHourisPast(11, values.deliveryDate)}
                            value={'11-13'}
                          >
                            {'11 الی 13'}
                          </MenuItem>
                          <MenuItem
                            disabled={checkHourisPast(14, values.deliveryDate)}
                            value={'14-16'}
                          >
                            {'14 الی 16'}
                          </MenuItem>
                        </TextField>
                      }
                    />
                    <FormHelperText error focused>
                      {errors?.deliveryTime &&
                        ' بازه تحویل محموله الزامی میباشد'}
                    </FormHelperText>
                  </span>
                </div>
              </Grid>
              <Grid container item xs={12} alignItems="flex-end">
                <div className={classes.item}>
                  <span className={classes.label}>
                    <Icon
                      path={mdiMapMarkerOutline}
                      size={1}
                      className={classes.icon}
                    />
                  </span>

                  <div style={{width: '100%'}}>
                    {valueWarehouse ? (
                      <TextField
                        fullWidth
                        value={valueWarehouse?.address}
                        label="آدرس مقصد"
                        variant="filled"
                        inputProps={{readOnly: true}}
                      />
                    ) : (
                      <TextField
                        fullWidth
                        value={null}
                        label="آدرس مقصد"
                        className={classes.textInput}
                        inputProps={{readOnly: true}}
                      />
                    )}
                  </div>
                </div>
              </Grid>
              {transportationType === 'RONAD' ? (
                <Grid item xs={12}>
                  <Paper
                    elevation={3}
                    className={classes.paper}
                    variant="elevation"
                    square
                  >
                    <Grid container spacing={5}>
                      <Grid item xs={12} sm={6}>
                        <div className={classes.item}>
                          <span className={classes.label}>
                            <Icon
                              path={mdiCalendar}
                              size={1}
                              className={classes.icon}
                            />
                          </span>

                          <span style={{width: '100%'}}>
                            <MuiPickersUtilsProvider
                              utils={JalaliUtils}
                              locale="fa"
                            >
                              <DatePicker
                                id="pickDate"
                                name="pickDate"
                                label="تاریخ تحویل به ناوگان"
                                format="jYYYY/jMM/jDD"
                                disablePast
                                margin="normal"
                                disableToolbar
                                fullWidth
                                okLabel="تأیید"
                                cancelLabel="لغو"
                                defaultValue={null}
                                className={classes.textInput}
                                value={values.pickDate}
                                onChange={handlePickDateChange}
                                error={errors.hasOwnProperty('pickDate')}
                                helperText={
                                  errors.pickDate && errors.pickDate.message
                                }
                              />
                            </MuiPickersUtilsProvider>
                          </span>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div className={classes.item}>
                          <span className={classes.label}>
                            <Icon
                              path={mdiCalendarClock}
                              size={1}
                              className={classes.icon}
                            />
                          </span>

                          <span style={{width: '100%'}}>
                            <MuiPickersUtilsProvider
                              utils={JalaliUtils}
                              locale="fa"
                            >
                              <TimePicker
                                id="pickTime"
                                name="pickTime"
                                label="زمان تحویل به ناوگان"
                                margin="normal"
                                ampm={false}
                                fullWidth
                                okLabel="تأیید"
                                cancelLabel="لغو"
                                value={values.pickTime}
                                className={classes.textInput}
                                onChange={handlePickTimeChange}
                                error={errors.hasOwnProperty('pickTime')}
                                helperText={
                                  errors.pickTime && errors.pickTime.message
                                }
                              />
                            </MuiPickersUtilsProvider>
                          </span>
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <Grid container item xs={12} alignItems="flex-end">
                          <div className={classes.item}>
                            <span className={classes.label}>
                              <Icon
                                path={mdiMapMarkerOutline}
                                size={1}
                                className={classes.icon}
                              />
                            </span>

                            <div style={{width: '100%'}}>
                              <TextField
                                fullWidth
                                name="pickAddress"
                                id="pickAddress"
                                label="آدرس جمع آوری"
                                className={classes.textInput}
                                inputRef={register({required: false})}
                                error={errors.pickAddress && true}
                              />
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <MapPosition
                          zoom={14}
                          center={{lat: 35.6892, lng: 51.389}}
                          position={latLng}
                          setLatlng={(latLng: {lat: number; lng: number}) => {
                            setLatLng(latLng);
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
              ) : null}
            </Grid>
          </Paper>
          <Grid container item xs={12} alignItems="flex-start">
            <div
              className={classes.item}
              style={{flexDirection: 'column', alignItems: 'flex-end'}}
            >
              <Button
                variant="contained"
                color="secondary"
                size="large"
                startIcon={<Icon path={mdiPlus} size={1} />}
                onClick={() => {
                  setOpenAddItem(true);
                }}
              >
                {'افزودن کالا به محموله'}
              </Button>
            </div>
          </Grid>
          <Grid container item xs={12} alignItems="flex-end">
            <div className={classes.item}>
              {itemsInfo.length > 0 && (
                <AddItemsParcelsList
                  data={itemsInfo}
                  deleteItem={(body: any) => setConfirmDelete(body)}
                />
              )}
            </div>
          </Grid>
          <Grid item container justify="flex-end" xs={12}>
            <Button
              type="submit"
              size="large"
              data-cy="search"
              autoFocus
              variant="contained"
              color="secondary"
              disabled={
                Object.keys(flattenObject(removeEmptyValueObject({...watch()})))
                  .length === 0
              }
            >
              {'ایجاد محموله جدید'}
            </Button>
          </Grid>
        </Grid>
      </form>

      <Dialog
        open={openConfirmDelete}
        fullWidth
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
          </div>
          <div
            className={classes.cancelTitle}
          >{`از حذف محموله با شناسه ${itemDeleted.id} مطمئن هستید؟`}</div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={deleteItemsToParcels}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        open={checkSubmit}
        fullWidth
        onClose={handleCloseCheckConfirm}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton aria-label="close" onClick={handleClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiCheck} size={4} color={theme.palette.success.main} />
          </div>
          <div className={classes.cancelTitle}>
            {`ایا از ایجاد محموله برای انبار "${
              checkSubmit ? valueWarehouse?.name : ''
            }" مطمئنید؟`}
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseCheckConfirm}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleCreateParcel}
                size="large"
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openDimensions}
        onClose={handleCloseDimensions}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleCloseDimensions ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleCloseDimensions}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.addIcon}>
            <Icon path={mdiCubeOutline} size={4} color="#039590" />
          </div>
          {boxCount && openListDimensions ? (
            <Grid container alignItems="center" spacing={4}>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiCounter} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="count"
                    name="count"
                    value={count}
                    onChange={e => setCount(e.target.value)}
                    label="تعداد"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiTableRowHeight} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="length"
                    name="length"
                    value={length}
                    onChange={e => setLength(e.target.value)}
                    label="طول"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiTableColumnWidth} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="width"
                    name="width"
                    value={width}
                    onChange={e => setWidth(e.target.value)}
                    label="عرض"
                  />
                </Grid>
              </Grid>
              <Grid
                container
                item
                xs={12}
                sm={6}
                spacing={1}
                alignItems="flex-end"
              >
                <Grid item xs={2}>
                  <Icon path={mdiRuler} size={1} />
                </Grid>
                <Grid item xs={10}>
                  <TextField
                    fullWidth
                    id="height"
                    name="height"
                    value={height}
                    onChange={e => setHeight(e.target.value)}
                    label="ارتفاع"
                  />
                </Grid>
              </Grid>
              {dimensions.length !== 0 && (
                <Grid item xs={12}>
                  <ListDimensions data={dimensions} modal />
                </Grid>
              )}
            </Grid>
          ) : (
            <Grid container spacing={1} alignItems="flex-end">
              <Grid item xs={12}>
                <p>{'تعداد بسته بندی های محموله را وارد کنید'}</p>
              </Grid>
              <Grid item xs={1}>
                <Icon path={mdiCounter} size={1} />
              </Grid>
              <Grid item xs={11}>
                <TextField
                  fullWidth
                  id="boxCount"
                  name="boxCount"
                  value={boxCount}
                  onChange={e => setBoxCount(e.target.value)}
                  label="تعداد بسته"
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          {boxCount && openListDimensions ? (
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={
                    totalBoxCount < Number(boxCount)
                      ? addDimensions
                      : setUpdateStatus
                  }
                  variant="contained"
                  color="secondary"
                  disabled={checkButtonDisabled()}
                  size="large"
                >
                  {totalBoxCount >= Number(boxCount)
                    ? 'مرحله بعد'
                    : 'اضافه کردن بسته'}
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handleClose()}
                  size="large"
                >
                  {'بازگشت'}
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={() => setOpenListDimensions(true)}
                  variant="contained"
                  color="secondary"
                  disabled={!boxCount}
                  size="large"
                >
                  {'مرحله بعد'}
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={() => handleCloseDimensions()}
                  size="large"
                >
                  {'بستن'}
                </Button>
              </Grid>
            </Grid>
          )}
        </DialogActions>
      </Dialog>
      <Modal
        maxWidth="sm"
        onClose={() => setOpenAddItem(false)}
        open={openAddItem}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiArchiveOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <AddItemsParcelsForm
            addItem={(body: AddItemCreateParcel) => createItemsToParcels(body)}
            onClose={() => setOpenAddItem(false)}
          />
        }
      />

      <Modal
        maxWidth="sm"
        onClose={() => setOpenAddInventoryItem(false)}
        open={openAddInventoryItem}
        title={
          <div className={classes.addIcon}>
            <Icon
              path={mdiArchiveOutline}
              size={4}
              color={theme.palette.green.main}
            />
          </div>
        }
        content={
          <AddInventoryItemsParcelsForm
            product={productObject}
            variant={variantObject}
            count={itemCount}
            hasExpirationDate={hasExpirationDateTime}
            addItem={(body: AddInventoryItemCreateParcel[]) =>
              createInventoryItemsToParcels(body)
            }
            onClose={() => setOpenAddInventoryItem(false)}
          />
        }
      />
    </>
  );
}

// const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
//   parcelsList: makeSelectList(),
//   count: makeSelectCountList(),
//   loading: makeSelectLoading(),
//   error: makeSelectError(),
// });

// function mapDispatchToProps(dispatch: Function) {
//   return {
//     createParcelsDispatch: (payload: PayloadCreate) =>
//       dispatch(createParcelsActions(payload)),
//   };
// }
// const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default Add;
